// import { environment } from '@src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import * as env from '@src/environments/environment';

export default class Utils {
    static getBookType(): string {
        let bookT = '';
        let subDomain = window.location.hostname.split('.')[0];
        if ((env.environment.environmentName === 'skfrtest') 
              || (subDomain === 'kfr')
              || (subDomain === 'kfrtest')
              || (env.environment.environmentName === 'skfrdev') 
        ) 
        {
            subDomain = 'kfr';
        }
        else if((env.environment.environmentName === 'kbwtest') 
          || (env.environment.environmentName === 'kbwdev') 
          || (subDomain === 'kbw')
          || (subDomain === 'kbwtest')
        )
        {
          subDomain = 'kbw';
        }
/////////////////////
        //subDomain = 'kfr';
/////////////////////
        switch (subDomain) {
            case 'kfr':
                bookT = 'SKFRDriver';
                break;
            case 'kbw':
              bookT = 'KBW';
              break;
            default:
                bookT = 'KBK';
        }
        return bookT;
      }
      static setLang(translate: TranslateService, langParam, bookType?) {
        //////////////////
        if ( !bookType) {
          bookType = Utils.getBookType();
        }
        if (!langParam && (!bookType || 
          ((bookType.trim().toLowerCase() === 'kbk') || bookType.trim().toLowerCase() === 'kbw'))) {
          langParam = 'pl-PL';
        }
        if (bookType === 'SKFRDriver' && !langParam) {
          langParam = 'fr-FR'; //TODO: change to fr lang
        }
        //////////////////
    
        sessionStorage.setItem('lang', langParam);
        sessionStorage.setItem('bookType', bookType);
        translate.use(langParam);
      }
      static convertDate(date:string): string{
        if(!date){
          return '';
        }
        const dt = new Date(date);
        
        const year = dt.getFullYear();
        const month = (dt.getMonth() + 1).toString().padStart(2, "0"); 
      
        const day = dt.getDate().toString().padStart(2, "0");
        
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    
      }
}
